import { render } from "./BpmnDiagramActionsShapeTopTransform.vue?vue&type=template&id=a3a3af70&scoped=true"
import script from "./BpmnDiagramActionsShapeTopTransform.vue?vue&type=script&lang=js"
export * from "./BpmnDiagramActionsShapeTopTransform.vue?vue&type=script&lang=js"

import "./BpmnDiagramActionsShapeTopTransform.vue?vue&type=style&index=0&id=a3a3af70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a3af70"]])

export default __exports__